/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const Document = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 15 19">
      <g transform="translate(-1 -1)">
        <path d="M15.5,20 L1.5,20 C1.22385763,20 1,19.7761424 1,19.5 L1,5.5 C1,5.22385763 1.22385763,5 1.5,5 C1.77614237,5 2,5.22385763 2,5.5 L2,19 L15,19 L15,2 L5.5,2 C5.22385763,2 5,1.77614237 5,1.5 C5,1.22385763 5.22385763,1 5.5,1 L15.5,1 C15.7761424,1 16,1.22385763 16,1.5 L16,19.5 C16,19.7761424 15.7761424,20 15.5,20 Z" />
        <path d="M5.5 6L1.5 6C1.28374397 6.01602406 1.08180972 5.89082483 1 5.69.916222642 5.50513059.960581966 5.28736664 1.11 5.15L5.11 1.15C5.24457623.970681456 5.48536109.908409508 5.69 1 5.89082483 1.08180972 6.01602406 1.28374397 6 1.5L6 5.5C6 5.77614237 5.77614237 6 5.5 6zM2.71 5L5 5 5 2.71 2.71 5zM12.5 10L4.5 10C4.22385763 10 4 9.77614237 4 9.5 4 9.22385763 4.22385763 9 4.5 9L12.5 9C12.7761424 9 13 9.22385763 13 9.5 13 9.77614237 12.7761424 10 12.5 10zM12.5 13L4.5 13C4.22385763 13 4 12.7761424 4 12.5 4 12.2238576 4.22385763 12 4.5 12L12.5 12C12.7761424 12 13 12.2238576 13 12.5 13 12.7761424 12.7761424 13 12.5 13zM12.5 16L4.5 16C4.22385763 16 4 15.7761424 4 15.5 4 15.2238576 4.22385763 15 4.5 15L12.5 15C12.7761424 15 13 15.2238576 13 15.5 13 15.7761424 12.7761424 16 12.5 16z" />
      </g>
    </BaseSvgIcon>
  )
}

export default Document
